/**
 * LBR2-D2 careers-page — pure display formatters for public opening cards.
 * Prisma `Decimal` fields (min/maxExperienceYears) serialise to JSON as strings,
 * so these coerce with Number() and guard null/''.
 */
const EMP_LABELS: Record<string, string> = {
  full_time: 'Full-time',
  part_time: 'Part-time',
  contract: 'Contract',
  apprentice: 'Apprentice',
  intern: 'Intern',
};

export function formatEmploymentType(v: string): string {
  if (EMP_LABELS[v]) return EMP_LABELS[v];
  const s = (v || '').replace(/_/g, ' ').trim();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
}

export function formatExperienceRange(
  min: string | number | null,
  max: string | number | null,
): string | null {
  const lo = min == null || min === '' ? null : Number(min);
  const hi = max == null || max === '' ? null : Number(max);
  if (lo == null && hi == null) return null;
  if (lo != null && hi != null) return `${lo}–${hi} yrs`;
  if (lo != null) return `${lo}+ yrs`;
  return `up to ${hi} yrs`;
}

export function formatPostedDate(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}
